import AppBar from '@mui/material/AppBar'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { Theme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import { Link } from 'react-router-dom'

import Logo from '@/assets/images/logo.svg?react'
import CreateAssessmentButton from '@/modules/assessments/components/CreateAssessmentButton'
import { LoginButton } from '@/modules/auth/components/LoginButton.tsx'
import { LogoutButton } from '@/modules/auth/components/LogoutButton.tsx'
import { useUser } from '@/modules/auth/hooks/useUser.ts'
import { TopNav } from '@/modules/layouts/TopNav'

const sxStack = { marginLeft: 'auto' }
const sxButton = {
  textTransform: 'uppercase',
}

const sxAppbar = (theme: Theme) => ({
  borderBottom: '1px solid' + theme.palette.customGrey.light,
})

const sxContainer = (theme: Theme) => ({
  [theme.breakpoints.up('sm')]: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})

export const Header = () => {
  const { user } = useUser()
  return (
    <header>
      <AppBar position="static" color="white" sx={sxAppbar}>
        <Container maxWidth="xl" sx={sxContainer}>
          <Toolbar>
            <Link to="/">
              <Logo title="Arz Care Homepage" />
            </Link>
            {user && <TopNav />}
            <Stack direction="row" spacing={1.5} sx={sxStack}>
              {!user && <LoginButton sx={sxButton} />}
              {user && (
                <>
                  <CreateAssessmentButton sx={sxButton} />
                  <LogoutButton sx={sxButton} />
                </>
              )}
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
    </header>
  )
}
